import * as Types from '../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type OrderabilityFragmentFragment = {
  __typename: 'OrderabilityOutput'
  prioritisedGenerallyAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
  prioritisedCurrentlyAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
  prioritisedGenerallyLocationAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
  prioritisedCurrentlyLocationAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
  delivery: {
    __typename: 'FulfilmentMethodOrderability'
    isGenerallyAvailable: boolean
    isAvailableToLocation: boolean
    asap: {
      __typename: 'FulfilmentMethodASAPOrderability'
      isGenerallyAvailable: boolean
      isAvailableNow: boolean
      availableFrom: string | null
      validUntil: string | null
    }
    preorder: {
      __typename: 'FulfilmentMethodPreorderOrderability'
      isGenerallyAvailable: boolean
      isAvailableForSelectedDate: boolean
      nextPreorderFulfilledAt: string | null
      isPreorderForLocalToday: boolean | null
    }
  }
  collection: {
    __typename: 'FulfilmentMethodOrderability'
    isGenerallyAvailable: boolean
    isAvailableToLocation: boolean
    asap: {
      __typename: 'FulfilmentMethodASAPOrderability'
      isGenerallyAvailable: boolean
      isAvailableNow: boolean
      availableFrom: string | null
      validUntil: string | null
    }
    preorder: {
      __typename: 'FulfilmentMethodPreorderOrderability'
      isGenerallyAvailable: boolean
      isAvailableForSelectedDate: boolean
      nextPreorderFulfilledAt: string | null
      isPreorderForLocalToday: boolean | null
    }
  }
  table: {
    __typename: 'FulfilmentMethodOrderability'
    isGenerallyAvailable: boolean
    isAvailableToLocation: boolean
    asap: {
      __typename: 'FulfilmentMethodASAPOrderability'
      isGenerallyAvailable: boolean
      isAvailableNow: boolean
      availableFrom: string | null
      validUntil: string | null
    }
    preorder: {
      __typename: 'FulfilmentMethodPreorderOrderability'
      isGenerallyAvailable: boolean
      isAvailableForSelectedDate: boolean
      nextPreorderFulfilledAt: string | null
      isPreorderForLocalToday: boolean | null
    }
  }
  anyFulfilmentMethod: {
    __typename: 'FulfilmentMethodOrderability'
    isGenerallyAvailable: boolean
    isAvailableToLocation: boolean
    asap: {
      __typename: 'FulfilmentMethodASAPOrderability'
      isGenerallyAvailable: boolean
      isAvailableNow: boolean
      availableFrom: string | null
      validUntil: string | null
    }
    preorder: {
      __typename: 'FulfilmentMethodPreorderOrderability'
      isGenerallyAvailable: boolean
      isAvailableForSelectedDate: boolean
      nextPreorderFulfilledAt: string | null
      isPreorderForLocalToday: boolean | null
    }
  }
}

export const OrderabilityFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OrderabilityFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'OrderabilityOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delivery' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isGenerallyAvailable' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isAvailableToLocation' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asap' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isGenerallyAvailable' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAvailableNow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableFrom' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'validUntil' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preorder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isGenerallyAvailable' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'isAvailableForSelectedDate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'nextPreorderFulfilledAt',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'isPreorderForLocalToday',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isGenerallyAvailable' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isAvailableToLocation' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asap' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isGenerallyAvailable' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAvailableNow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableFrom' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'validUntil' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preorder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isGenerallyAvailable' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'isAvailableForSelectedDate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'nextPreorderFulfilledAt',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'isPreorderForLocalToday',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'table' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isGenerallyAvailable' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isAvailableToLocation' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asap' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isGenerallyAvailable' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAvailableNow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableFrom' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'validUntil' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preorder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isGenerallyAvailable' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'isAvailableForSelectedDate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'nextPreorderFulfilledAt',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'isPreorderForLocalToday',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'anyFulfilmentMethod' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isGenerallyAvailable' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isAvailableToLocation' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asap' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isGenerallyAvailable' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAvailableNow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availableFrom' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'validUntil' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'preorder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isGenerallyAvailable' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'isAvailableForSelectedDate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'nextPreorderFulfilledAt',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'isPreorderForLocalToday',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'prioritisedGenerallyAvailableFulfilmentMethods',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'prioritisedCurrentlyAvailableFulfilmentMethods',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'prioritisedGenerallyLocationAvailableFulfilmentMethods',
            },
          },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'prioritisedCurrentlyLocationAvailableFulfilmentMethods',
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderabilityFragmentFragment, unknown>
